const TelegramLogo = '/networks/telegramLogo.svg';
const WhatsAppLogo = '/networks/whatsAppLogo.svg';
export const TELEGRAM_LINK = 'https://t.me/levelup_com';
export const WHATSAPP_LINK =
  'https://whatsapp.com/channel/0029VaxnPSwDzgTE1ywV5J0s';

export const licenseAttributes = {
  otherDomain: {
    id: 'apg-df94f8da-c877-459b-8c07-ef39854426db',
    'data-apg-seal-id': 'df94f8da-c877-459b-8c07-ef39854426db',
    'data-apg-image-size': '256',
    'data-apg-image-type': 'basic-light-large',
  },
  default: {
    id: 'apg-0aa16dab-6b0e-4c30-b208-c36d01701c3d',
    'data-apg-seal-id': '0aa16dab-6b0e-4c30-b208-c36d01701c3d',
    'data-apg-image-size': '64',
    'data-apg-image-type': 'basic-small',
  },
};

export const socialLinks = [
  {
    icon: TelegramLogo,
    link: TELEGRAM_LINK,
    alt: 'Telegram',
    width: 40,
    height: 40,
  },
  {
    icon: WhatsAppLogo,
    link: WHATSAPP_LINK,
    alt: 'WhatsApp',
    width: 40,
    height: 40,
  },
];

export const getFooterImages = (isEstonia: boolean, isAustralia: boolean) => [
  {
    src: '/footer/playResponsiblyLogo.svg',
    alt: 'responsibleGaming',
    href: 'https://levelupcasino.com/responsible-gaming',
    width: 110,
    height: 60,
    isHidden: isEstonia,
  },
  {
    src: 'https://cdn.softswiss.net/logos/responsibility/color_white/21plus.svg',
    alt: '21+',
    width: 60,
    height: 60,
    isHidden: !isEstonia,
  },
  {
    src: 'https://cdn.softswiss.net/logos/license/EE.svg',
    alt: 'EE license',
    width: 50,
    height: 60,
    isHidden: !isEstonia,
    href: 'https://mtr.ttja.ee/taotluse_tulemus/603379',
  },
  {
    src: '/footer/gcb.svg',
    alt: 'GCB',
    width: 150,
    height: 60,
    isHidden: isAustralia,
    href: 'https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbGRUVDFSRWVXSnpWMmR5TVM5R1RHMURlRUpXUWxFOVBTSXNJblpoYkhWbElqb2llRU5rVW1ob2NUTmFXa1JSZERnNFZXNVdiMXByYzJKQ2RHdGpTbEpsWmtOWVZISkxObUZMV2tZdlZUMGlMQ0p0WVdNaU9pSTJaVGcxTnpZNU5qSmhPREZqTmpNd1pHUmhaamc0WXpNeU5HSTNZamd5T0dKbFpHWmxNMlpoTWpNM1lqSTVOR1V4WXpFNU5tSTRZekUwTlRSa09USTBJaXdpZEdGbklqb2lJbjA9',
  },
];

export const getPartnersImages = (isAustralia: boolean) => [
  {
    src: '/footer/MrGambleSeal.webp',
    alt: 'LevelUp Casino Review At MrGamble',
    href: 'https://mr-gamble.com/ca/online-casino/levelup-casino/',
    width: 46,
    isHidden: isAustralia,
  },
  {
    src: '/footer/ask2Place.svg',
    alt: 'ask2Place',
    href: 'https://awards.askgamblers.com/winners/',
    width: 63,
  },
  {
    src: '/footer/casinoOnlineApproved.svg',
    alt: 'Casino-on-line.com approved',
    href: 'https://www.casino-on-line.com/review/level-up-casino/',
    width: 115,
  },
  {
    src: '/footer/askGamblersCertificate.svg',
    alt: 'Askgamblers Certificate',
    href: 'https://www.askgamblers.com/online-casinos/levelup-casino-review/',
    width: 130,
  },
  {
    src: '/footer/casinosAnalyzer.webp',
    alt: 'casinosAnalyzer',
    href: 'https://casinosanalyzer.com/online-casinos/real-money',
    width: 107,
  },
  {
    src: '/footer/clashOfSlots.webp',
    alt: 'clashOfSlots',
    href: 'https://clashofslots.com/casinos/levelup/',
    width: 109,
  },
  {
    src: '/footer/chipyLogo.webp',
    alt: 'Chipo',
    href: 'https://chipy.com/casinos/levelup-casino-review',
    width: 86,
  },
  {
    src: '/footer/gamblizard.svg',
    alt: 'gamblizard',
    href: 'https://gamblizard.de/beste-online-casinos/handy/',
    width: 130,
  },
  {
    src: '/footer/slotozilla.svg',
    alt: 'slotozilla',
    href: 'https://www.slotozilla.com/',
    width: 125,
  },
];

export const awardsImages = [
  {
    src: '/footer/awards/players-choice-medal.svg',
    alt: 'players choice',
  },
  {
    src: '/footer/awards/new-casino-medal.svg',
    alt: 'new casino',
  },
  {
    src: '/footer/awards/members-choice-medal.svg',
    alt: 'members choice',
  },
  {
    src: '/footer/awards/online-casino-medal.svg',
    alt: 'online casino',
  },
  {
    src: '/footer/awards/prime-perks-medal.svg',
    alt: 'prime perks',
  },
];

export enum CustomFooterGroups {
  STRUKIN = 'strukin',
  FRIOLION = 'friolion',
}

export const COPYRIGHT_CONFIG = {
  estonia: {
    i18nKey: 'footer.copyrightEt',
    links: {
      terms: '/terms-and-conditions-ee',
      responsibleGaming: '/responsible-gaming-ee',
    },
  },
  alternative: {
    i18nKey: 'footer.copyrightAlternative',
    links: {
      terms: '/terms-and-conditions',
      responsibleGaming: '/responsible-gaming',
    },
  },
  [CustomFooterGroups.STRUKIN]: {
    i18nKey: 'footer.copyrightStrukin',
    links: {
      terms: '/terms-and-conditions',
      responsibleGaming: '/responsible-gaming',
    },
  },
  [CustomFooterGroups.FRIOLION]: {
    i18nKey: 'footer.copyrightFriolin',
    links: {
      terms: '/terms-and-conditions',
      responsibleGaming: '/responsible-gaming',
    },
  },
  default: {
    i18nKey: 'footer.copyright',
    links: {
      terms: '/terms-and-conditions',
      responsibleGaming: '/responsible-gaming',
    },
  },
};
